<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3332 6.99996H1.6665M1.6665 6.99996L7.49984 12.8333M1.6665 6.99996L7.49984 1.16663"
      stroke="#667085"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped>
svg {
  stroke: currentColor !important;
  font-size: 15px;
}
</style>
